import actions from "~/shared/actions";

export const defaultState = [];

export default function utbetalingsoversiktReducer(state = defaultState, action) {
	switch (action.type) {
		case actions.GET_UTBETALINGSOVERSIKT_RESPONSE: {
			const { policyNumber, utbetalingsoversikt } = action.data;

			return Array.from(state)
				.filter((p) => p.policyNumber !== policyNumber)
				.concat({ utbetalingsoversikt, policyNumber });
		}
		default:
			return state;
	}
}
